import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';

var _templateObject = _taggedTemplateLiteral(['\n  color: ', ';\n  font-size: 15px;\n  font-weight: 600;\n  margin: 0;\n  text-transform: capitalize;\n  ', '\n  span {\n    color: ', ';\n    font-weight: 500;\n  }\n'], ['\n  color: ', ';\n  font-size: 15px;\n  font-weight: 600;\n  margin: 0;\n  text-transform: capitalize;\n  ', '\n  span {\n    color: ', ';\n    font-weight: 500;\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  color: ', ';\n  display: block;\n  font-size: 11px;\n  font-weight: 500;\n  letter-spacing: 0.7px;\n  margin-bottom: 10px;\n  text-transform: uppercase;\n'], ['\n  color: ', ';\n  display: block;\n  font-size: 11px;\n  font-weight: 500;\n  letter-spacing: 0.7px;\n  margin-bottom: 10px;\n  text-transform: uppercase;\n']);

import styled from 'styled-components';

export var StyledTitle = styled.h5(_templateObject, function (props) {
  return props.theme.dormifyBlack;
}, !window.Dormify.shipLaterEnabled && '\n    margin-bottom: 10px;\n  ', function (props) {
  return props.theme.dormifyGrey;
});

export var StyledSubTitle = styled.p(_templateObject2, function (props) {
  return props.theme.dormifyBoulder;
});